import AccountPlanPage from '@totem/components/accountPlan/AccountPlanPage';
import ConfigurationPage from '@totem/components/administration/account/configuration/configurationPage';
import ContactsPage from '@totem/components/administration/account/contacts/contactsPage';
import OrgChartPage from '@totem/components/administration/account/orgChart/orgChartPage';
import SalesOrdersPage from '@totem/components/administration/account/salesOrders/salesOrdersPage';
import AccountServicesPage from '@totem/components/administration/account/services/servicesPage';
import AmazonWebServicesPage from '@totem/components/administration/amazonWebServices/AmazonWebServicesPage';
import ApiConnectionsPage from '@totem/components/administration/apiConnections/ApiConnectionsPage';
import ApiManagementPage from '@totem/components/administration/apis/ApiManagementPage';
import ApiSitesPage from '@totem/components/administration/apiSites/ApiSitesPage';
import Auth0RolesPage from '@totem/components/administration/auth0/roles/Auth0RolesPage';
import BouncedEmailsPage from '@totem/components/administration/bouncedEmails/BouncedEmailsPage';
import BouncedEmailDetailsPage from '@totem/components/administration/bouncedEmails/details/BouncedEmailDetailsPage';
import ConfigurationManagementPage from '@totem/components/administration/configuration/configurationManagement';
import DataManagementPage from '@totem/components/administration/dataManagement/dataManagement';
import DeviceSyncMergesPage from '@totem/components/administration/deviceSyncMerges/DeviceSyncMergesPage';
import GlobalContactsPage from '@totem/components/administration/globalContacts/GlobalContactsPage';
import LogManagementPage from '@totem/components/administration/logManagement/logManagement';
import LogSyncDetailsPage from '@totem/components/administration/logSync/details/LogSyncDetailsPage';
import LogSyncPage from '@totem/components/administration/logSync/LogSyncPage';
import Mappings from '@totem/components/administration/mappings/Mappings';
import MappingsManagementPage from '@totem/components/administration/mappings/mappingsPage';
import SavingsTypesPage from '@totem/components/administration/optimize/savingsTypes/savingsTypesPage';
import NozomiReconciliationPage from '@totem/components/administration/reconciliation/nozomi/NozomiReconciliationPage';
import ServicesPage from '@totem/components/administration/services/ServicesPage';
import StorageReportPage from '@totem/components/administration/storageReporting/StorageReportPage';
import BillingRateReportPage from '@totem/components/billingRates/BillingRateReportPage';
import CyberReportPage from '@totem/components/cyberReview/CyberReportPage';
import Holidays from '@totem/components/holidays/Holidays';
import RuleDetailsPage from '@totem/components/rulesEngine/details/ruleDetailsPage';
import RulesPage from '@totem/components/rulesEngine/report/rulesPage';
import CommissioningReportPage from '@totem/components/salesOrders/commissioning/CommissioningReportPage';
import DecommissioningReportPage from '@totem/components/salesOrders/decommissioning/DecommissioningReportPage';
import EventConfigurationPage from '@totem/components/services/threats/configuration/EventConfigurationPage';
import ZoneMappingPage from '@totem/components/settings/sections/nozomi/zoneMappings/ZoneMappingPage';
import Settings from '@totem/components/settings/Settings';
import BillingPage from '@totem/components/ticketing/billing/billingPage';
import SingleBillingPage from '@totem/components/ticketing/billing/singleBilling/billingItemPage';
import EmployeeUtilizationDetailsPage from '@totem/components/ticketing/employeeUtilization/employeeUtilizationDetailsPage';
import EmployeeUtilizationReportPage from '@totem/components/ticketing/employeeUtilization/employeeUtilizationReportPage';
import { getMenuAdminAPIs } from '@totem/components/ui_components/menus/mainMenu/admin_apis';
import { getMenuAdminConfiguration } from '@totem/components/ui_components/menus/mainMenu/admin_configuration';
import { getMenuAdminDataManagement } from '@totem/components/ui_components/menus/mainMenu/admin_dataMgmt';
import { getMenuAdminLogManagement } from '@totem/components/ui_components/menus/mainMenu/admin_logManagement';
import { getMenuAdminMappings } from '@totem/components/ui_components/menus/mainMenu/admin_mappings';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import StylesTest from '@totem/components/utilities/styles/Styles';
import { Route } from '@totem/types/route';
import { UserProfile } from '@totem/types/user';

export const administrativeRoutes: Route[] = [
  {
    path: 'settings',
    pageTitle: 'Account Settings',
    component: Settings,
    exact: true,
    breadcrumbs: [{ label: 'Account Settings' }],
    render: (userProfile: UserProfile) =>
      permissions.systemAdministrator.hasPermissions(userProfile),
  },
  {
    path: 'account/configuration',
    pageTitle: 'Account Configuration',
    component: ConfigurationPage,
    exact: true,
    breadcrumbs: [{ label: 'Account Configuration' }],
    render: (userProfile: UserProfile) =>
      permissions.systemAdministrator.hasPermissions(userProfile),
  },
  {
    path: 'account/contacts',
    pageTitle: 'Organization Contacts',
    component: ContactsPage,
    exact: true,
    breadcrumbs: [{ label: 'Organization Contacts' }],
    render: (userProfile: UserProfile) =>
      permissions.systemAdministrator.hasPermissions(userProfile),
  },
  {
    path: 'account/orgChart',
    pageTitle: 'Org Chart',
    component: OrgChartPage,
    exact: true,
    breadcrumbs: [
      { label: 'Account Plan', link: '/admin/accountPlan' },
      { label: 'Org Chart' },
    ],
    render: (userProfile: UserProfile) =>
      permissions.internal.hasPermissions(userProfile),
  },
  {
    path: 'account/services',
    pageTitle: 'Services',
    component: AccountServicesPage,
    exact: true,
    breadcrumbs: [{ label: 'Organization Services' }],
    render: (userProfile: UserProfile) =>
      permissions.systemAdministrator.hasPermissions(userProfile),
  },
  {
    path: 'account/salesOrders',
    pageTitle: 'Sales Orders',
    component: SalesOrdersPage,
    exact: true,
    breadcrumbs: [{ label: 'Sales Orders' }],
    render: (userProfile: UserProfile) =>
      permissions.contractsViewer.hasPermissions(userProfile),
  },
  {
    path: 'admin/configuration',
    pageTitle: 'Configuration Management',
    component: ConfigurationManagementPage,
    exact: true,
    breadcrumbs: [{ label: 'Configuration Management' }],
    render: (userProfile: UserProfile) =>
      getMenuAdminConfiguration(userProfile).length > 0,
  },
  {
    path: 'admin/mappings',
    pageTitle: 'Mappings',
    component: Mappings,
    exact: true,
    breadcrumbs: [{ label: 'Mappings' }],
    render: (userProfile: UserProfile) =>
      permissions.internalSystemAdministrator.hasPermissions(userProfile),
  },
  {
    path: 'admin/mappingManagement',
    pageTitle: 'Mappings',
    component: MappingsManagementPage,
    exact: true,
    breadcrumbs: [{ label: 'Mappings' }],
    render: (userProfile: UserProfile) =>
      getMenuAdminMappings(userProfile).length > 0,
  },
  {
    path: 'admin/services',
    pageTitle: 'Service Definitions',
    component: ServicesPage,
    exact: true,
    breadcrumbs: [{ label: 'Service Definitions' }],
    render: (userProfile: UserProfile) =>
      permissions.internalSystemAdministrator.hasPermissions(userProfile),
  },
  {
    path: 'admin/eventConfiguration',
    pageTitle: 'Event Configuration',
    component: EventConfigurationPage,
    exact: true,
    breadcrumbs: [{ label: 'Event Configuration' }],
    render: (userProfile: UserProfile) =>
      permissions.internal.hasPermissions(userProfile),
  },
  {
    path: 'admin/optimizeSavingsTypes',
    pageTitle: 'Optimize Savings Types',
    component: SavingsTypesPage,
    exact: true,
    breadcrumbs: [{ label: 'Optimize Savings Types' }],
    render: (userProfile: UserProfile) =>
      permissions.internalSystemAdministrator.hasPermissions(userProfile),
  },
  {
    path: 'admin/salesOrderDecommissioning',
    pageTitle: 'Services Not On Contract',
    component: DecommissioningReportPage,
    exact: true,
    breadcrumbs: [{ label: 'Services Not On Contract' }],
    render: (userProfile: UserProfile) =>
      permissions.internalOrganizationalAdministrator.hasPermissions(
        userProfile,
      ),
  },
  {
    path: 'admin/salesOrderCommissioning',
    pageTitle: 'Sales Order Commissioning',
    component: CommissioningReportPage,
    exact: true,
    breadcrumbs: [{ label: 'Commissioning' }],
    render: (userProfile: UserProfile) =>
      permissions.internalOrganizationalAdministrator.hasPermissions(
        userProfile,
      ),
  },
  {
    path: 'admin/rules',
    pageTitle: 'Rules',
    component: RulesPage,
    exact: true,
    breadcrumbs: [{ label: 'Rules' }],
    render: (userProfile: UserProfile) =>
      permissions.ruleViewer.hasPermissions(userProfile),
  },
  {
    path: 'admin/rules/:id',
    pageTitle: 'Rule Details',
    component: RuleDetailsPage,
    exact: true,
    breadcrumbs: [
      { label: 'Rules', link: '/admin/rules' },
      { label: 'Rule Details' },
    ],
    render: (userProfile: UserProfile) =>
      permissions.ruleViewer.hasPermissions(userProfile),
  },
  {
    path: 'billingRatesReportPage',
    pageTitle: 'Billing Rates',
    component: BillingRateReportPage,
    exact: true,
    breadcrumbs: [{ label: 'Billing Rates Report' }],
    render: (userProfile: UserProfile) =>
      permissions.billingAdministratorIBOrg.hasPermissions(userProfile),
  },
  {
    path: 'admin/billing',
    pageTitle: 'Billing',
    component: BillingPage,
    exact: true,
    breadcrumbs: [{ label: 'Billing' }],
    render: (userProfile: UserProfile) =>
      permissions.billingAdministratorIBOrg.hasPermissions(userProfile),
  },
  {
    path: 'admin/billing/:id',
    pageTitle: 'Billing',
    component: SingleBillingPage,
    exact: true,
    breadcrumbs: [{ label: 'Billing' }],
    render: (userProfile: UserProfile) =>
      permissions.billingAdministratorIBOrg.hasPermissions(userProfile),
  },
  {
    path: 'utilization',
    pageTitle: 'Utilization',
    component: EmployeeUtilizationReportPage,
    exact: true,
    breadcrumbs: [{ label: 'Utilization' }],
    render: (userProfile: UserProfile) =>
      permissions.billingAdministratorIBOrg.hasPermissions(userProfile),
  },
  {
    path: 'utilization/:email',
    pageTitle: 'Utilization',
    component: EmployeeUtilizationDetailsPage,
    exact: true,
    breadcrumbs: [{ label: 'Utilization' }],
    render: (userProfile: UserProfile) =>
      permissions.internal.hasPermissions(userProfile),
  },
  {
    path: 'admin/holidays',
    pageTitle: 'Holidays',
    component: Holidays,
    exact: true,
    breadcrumbs: [{ label: 'Holiday Management' }],
    render: (userProfile: UserProfile) =>
      permissions.billingAdministratorIBOrg.hasPermissions(userProfile),
  },
  {
    path: 'stylesTest',
    pageTitle: 'Styles Test',
    component: StylesTest,
    exact: true,
    breadcrumbs: [],
  },
  {
    path: 'forbiddenTest',
    pageTitle: 'Forbidden Test',
    component: StylesTest,
    exact: true,
    breadcrumbs: [],
    render: (userProfile: UserProfile) => {
      return userProfile.email === 'NA';
    },
  },
  {
    path: 'zoneMappings',
    pageTitle: 'Zone Mappings',
    component: ZoneMappingPage,
    exact: true,
    breadcrumbs: [{ label: 'Zone Mappings' }],
    render: (userProfile: UserProfile) =>
      permissions.internalSystemAdministrator.hasPermissions(userProfile),
  },
  {
    path: 'cyberReportPage',
    pageTitle: 'Cyber Review',
    component: CyberReportPage,
    exact: true,
    breadcrumbs: [{ label: 'Cyber Review Report' }],
    render: (userProfile: UserProfile) =>
      permissions.internalSystemAdministratorIBOrg.hasPermissions(userProfile),
  },
  {
    path: 'admin/apiConnections',
    pageTitle: 'API Connections',
    component: ApiConnectionsPage,
    exact: true,
    breadcrumbs: [{ label: 'API Connections' }],
    render: (userProfile: UserProfile) =>
      permissions.configurationAdministrator.hasPermissions(userProfile),
  },
  {
    path: 'admin/apiManagement',
    pageTitle: 'API Management',
    component: ApiManagementPage,
    exact: true,
    breadcrumbs: [{ label: 'API Management' }],
    render: (userProfile: UserProfile) => {
      return getMenuAdminAPIs(userProfile).length > 0;
    },
  },
  {
    path: 'admin/dataManagement',
    pageTitle: 'Data Management',
    component: DataManagementPage,
    exact: true,
    breadcrumbs: [{ label: 'Data Management' }],
    render: (userProfile: UserProfile) => {
      return getMenuAdminDataManagement(userProfile).length > 0;
    },
  },
  {
    path: 'admin/logManagement',
    pageTitle: 'Log Management',
    component: LogManagementPage,
    exact: true,
    breadcrumbs: [{ label: 'Log Management' }],
    render: (userProfile: UserProfile) => {
      return getMenuAdminLogManagement(userProfile).length > 0;
    },
  },
  {
    path: 'admin/apiSites',
    pageTitle: 'API Sites',
    component: ApiSitesPage,
    exact: true,
    breadcrumbs: [{ label: 'API Sites' }],
    render: (userProfile: UserProfile) =>
      permissions.internalSystemAdministrator.hasPermissions(userProfile),
  },
  {
    path: 'admin/accountPlan',
    pageTitle: 'Account Plan',
    component: AccountPlanPage,
    exact: true,
    breadcrumbs: [{ label: 'Account Plan' }],
    render: (userProfile: UserProfile) =>
      permissions.internal.hasPermissions(userProfile),
  },
  {
    path: 'admin/reconciliation/nozomi',
    pageTitle: 'Nozomi Reconciliation',
    component: NozomiReconciliationPage,
    exact: true,
    breadcrumbs: [{ label: 'Nozomi Reconciliation' }],
    render: (userProfile: UserProfile) =>
      permissions.internal.hasPermissions(userProfile),
  },
  {
    path: 'admin/amazonWebServices',
    pageTitle: 'Amazon Web Services',
    component: AmazonWebServicesPage,
    exact: true,
    breadcrumbs: [{ label: 'Amazon Web Services' }],
    render: (userProfile: UserProfile) =>
      permissions.internal.hasPermissions(userProfile),
  },
  {
    path: 'admin/deviceSyncMerges',
    pageTitle: 'Device Sync Merges',
    component: DeviceSyncMergesPage,
    exact: true,
    breadcrumbs: [{ label: 'Device Sync Merges' }],
    render: (userProfile: UserProfile) =>
      permissions.internalSystemAdministrator.hasPermissions(userProfile),
  },
  {
    path: 'admin/globalContacts',
    pageTitle: 'Global Contacts',
    component: GlobalContactsPage,
    exact: true,
    breadcrumbs: [{ label: 'Global Contacts' }],
    render: (userProfile: UserProfile) =>
      permissions.internalSystemAdministratorIBOrg.hasPermissions(userProfile),
  },
  {
    path: 'admin/auth0Roles',
    pageTitle: 'Auth0 Roles',
    component: Auth0RolesPage,
    exact: true,
    breadcrumbs: [{ label: 'Auth0 Roles' }],
    render: (userProfile: UserProfile) =>
      permissions.internalSystemAdministrator.hasPermissions(userProfile),
  },
  {
    path: 'admin/logSync',
    pageTitle: 'Log Sync',
    component: LogSyncPage,
    exact: true,
    breadcrumbs: [{ label: 'Log Sync' }],
    render: (userProfile: UserProfile) =>
      permissions.internalSystemAdministrator.hasPermissions(userProfile),
  },
  {
    path: 'admin/logSync/:id',
    pageTitle: 'Log Sync Result',
    component: LogSyncDetailsPage,
    exact: true,
    breadcrumbs: [
      { label: 'Log Sync', link: '/admin/logSync' },
      { label: 'Result' },
    ],
    render: (userProfile: UserProfile) =>
      permissions.internalSystemAdministrator.hasPermissions(userProfile),
  },
  {
    path: 'admin/bouncedEmails',
    pageTitle: 'Bounced Emails',
    component: BouncedEmailsPage,
    exact: true,
    breadcrumbs: [{ label: 'Bounced Emails' }],
    render: (userProfile: UserProfile) =>
      permissions.internalSystemAdministrator.hasPermissions(userProfile),
  },
  {
    path: 'admin/bouncedEmails/:email',
    pageTitle: 'Bounced Email',
    component: BouncedEmailDetailsPage,
    exact: true,
    breadcrumbs: [
      { label: 'Bounced Emails', link: '/admin/bouncedEmails' },
      { label: 'Email' },
    ],
    render: (userProfile: UserProfile) =>
      permissions.internalSystemAdministrator.hasPermissions(userProfile),
  },
  {
    path: 'admin/storageReporting',
    pageTitle: 'Storage Reporting',
    component: StorageReportPage,
    exact: true,
    breadcrumbs: [{ label: 'Storage Reporting' }],
    render: (userProfile: UserProfile) =>
      permissions.internalSystemAdministrator.hasPermissions(userProfile),
  },
];
